import { rtkApi } from 'services/api/rtkApi'
import { API_URL_V2 } from 'consts'

export const RTK_INCOMING_ORDERS_TAG = 'IncomingOrders'
export const RTK_TRADE_LIMIT_TAG = 'TradeLimit'
export const RTK_CART_TAG = 'Cart'
export const RTK_CART_DELIVERIES_TAG = 'CartDeliveries'
export const RTK_CART_DELIVERY_ITEMS_TAG = 'CartDeliveryItems'

const cartApi = rtkApi
  .enhanceEndpoints({
    addTagTypes: [
      RTK_INCOMING_ORDERS_TAG,
      RTK_TRADE_LIMIT_TAG,
      RTK_CART_TAG,
      RTK_CART_DELIVERIES_TAG,
      RTK_CART_DELIVERY_ITEMS_TAG,
    ],
  })
  .injectEndpoints({
    endpoints: build => ({
      getCart: build.query({
        query: () => ({
          url: `${API_URL_V2}/me/cart`,
        }),
        providesTags: [RTK_CART_TAG],
      }),
      getCartDeliveries: build.query({
        query: () => ({
          url: `${API_URL_V2}/me/cart/deliveries`,
        }),
        providesTags: [RTK_CART_DELIVERIES_TAG],
      }),
      getCartDeliveryItems: build.query({
        query: ({ id }) => ({
          url: `${API_URL_V2}/me/cart/deliveries/${id}/items`,
        }),
        providesTags: (result, error, params) => [
          { type: RTK_CART_DELIVERY_ITEMS_TAG, id: params.id },
        ],
      }),
      getIncomingOrders: build.query({
        query: () => ({
          url: 'me/incoming_orders',
        }),
        transformResponse: res => res?.incomingOrders || [],
        providesTags: [RTK_INCOMING_ORDERS_TAG],
      }),
      getTradeLimit: build.query({
        query: () => ({
          url: 'me/trade_limit',
        }),
        providesTags: [RTK_TRADE_LIMIT_TAG],
      }),
      updateExpiredDeliveries: build.mutation({
        query: () => ({
          url: 'me/cart/expired_deliveries',
          method: 'PUT',
        }),
      }),
    }),
  })

export const {
  useGetCartQuery,
  useGetCartDeliveriesQuery,
  useGetCartDeliveryItemsQuery,
  useGetIncomingOrdersQuery,
  useGetTradeLimitQuery,
} = cartApi

export default cartApi
